<ng-container *ngIf="loaded">
  <div class="title" *ngIf="titleVisible">{{ playoff.name }}</div>
  <ng-container *ngIf="playoff.settings.type === playoffTypes.double_elimination">
    <mtg-tournament-playoff-bracket
      [playoff]="playoff"
      [winnerBracket]="true"
      [games]="winnerBracketGames"
      [gameRoute]="gameRoute"
      [openGameInNewWindow]="false"
      [currentRound]="winnerBracketActiveRound"
      [sport]="sport"
    ></mtg-tournament-playoff-bracket>
    <mtg-tournament-playoff-bracket
      [playoff]="playoff"
      [loserBracket]="true"
      [games]="loserBracketGames"
      [gameRoute]="gameRoute"
      [openGameInNewWindow]="false"
      [currentRound]="loserBracketActiveRound"
      [sport]="sport"
    ></mtg-tournament-playoff-bracket>
  </ng-container>
  <mtg-tournament-playoff-bracket
    *ngIf="playoff.settings.type === playoffTypes.elimination"
    [playoff]="playoff"
    [games]="games"
    [gameRoute]="gameRoute"
    [openGameInNewWindow]="false"
    [currentRound]="activeRound"
    [sport]="sport"
  ></mtg-tournament-playoff-bracket>
</ng-container>
<mtg-spinner *ngIf="!loaded"></mtg-spinner>
